// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';

const Title = 'Expand';

export function Expand() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{Title}</title>
      <g fill="currentColor" fillRule="nonzero">
        <path d="M2.207 14.24H6.6v1H.5v-6.1h1v4.392l5.086-5.086.707.707-5.086 5.087zM13.532 1.5H9.14v-1h6.1v6.1h-1V2.207L9.153 7.293l-.707-.707L13.532 1.5z" />
      </g>
    </svg>
  );
}
